export default __webpack_public_path__ + "static/media/bannerdemo_image1.4c9f5b00.jpeg";